import { TabType } from '../Store_WMS2011_R01';

export const WMS2011_R01_TABS = [
    { id: 'total', label: '전체 재고' },
    { id: 'item', label: '품목별 재고' },
    { id: 'warehouse', label: '창고별 재고' },
    { id: 'logiccenter', label: '물류센터별 재고' },
] as const;

// 공통 rowId 생성 함수
export const generateRowId = (item: any, tab: TabType): string => {
    switch (tab) {
        case 'item':
            // 품목별: 품목코드 + 브랜드코드로 고유성 보장
            return `${item.itemCd}-${item.brandCd || 'DEFAULT'}`;
        case 'warehouse':
            // 창고별: 물류센터 + 창고코드 + 품목코드 + 등급 + 브랜드
            return `${item.logicCenter}-${item.warehouseCd}-${item.itemCd}-${item.itemStatus}-${item.brandCd || 'DEFAULT'}`;
        case 'logiccenter':
            // 물류센터별: 물류센터코드 + 창고코드 + 품목코드 + 등급 + 브랜드
            return `${item.logicCenter}-${item.warehouseCd}-${item.itemCd}-${item.itemStatus}-${item.brandCd || 'DEFAULT'}`;
        case 'total':
            // 전체: 물류센터 + 창고 + 품목 + 등급 + 브랜드로 완전 고유성 보장
            return `${item.logicCenter}-${item.warehouseCd}-${item.itemCd}-${item.itemStatus}-${item.brandCd || 'DEFAULT'}`;
        default:
            return '';
    }
};

// 소계 rowId 생성 함수
export const generateSubtotalRowId = (item: any): string => {
    return `subtotal_${item?.groupKey || item?.itemCd || 'EMPTY'}`;
};

// 소계/상세를 모두 포함한 rowId 생성 함수
export const generateGridRowId = (item: any, tab: TabType): string => {
    if (item?.isSubtotal) {
        return generateSubtotalRowId(item);
    }
    return generateRowId(item, tab);
};
